// Must precede anything that can pull in pdfjs — see the file for why.
import 'src/polyfills/urlParse';
import { createRoot } from 'react-dom/client';
import App from 'src/App';
import {
  captureUtmsFromUrl,
  captureReferralHashFromUrl,
  captureSessionSourceFromUrl,
} from 'src/helpers/utmCapture';
import trackAppHeight from 'src/helpers/appHeight';
import { initCtaTracking } from 'src/helpers/ctaTracking';
import { captureFreeUnlockOfferIntent } from 'src/helpers/freeUnlockOfferIntent';
import { purgeUnusableTokens } from 'src/helpers/storedToken';
import 'src/assets/fonts/resume-fonts.css';
import 'src/index.css';

// First, before any layout, the socket handshake or the auth slice can read a
// token: a v1 "forever token" carries no `exp`, so the backend rejects it every
// time. Booting on one buys a flash of the signed-in UI and then an eject to
// the landing page; dropping it here starts the app cleanly logged-out instead.
purgeUnusableTokens();
captureUtmsFromUrl();
captureSessionSourceFromUrl();
captureReferralHashFromUrl();
// Before React mounts: the offer link lands on routes that redirect (and drop the
// query string) long before any component could read it.
captureFreeUnlockOfferIntent();
trackAppHeight();
// Delegated listeners, so they must be installed before the first render can
// paint a CTA the user could click.
initCtaTracking();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
